/**
 * Quick Add Button Cleanup - Performance Optimized
 * Removes duplicate quick-add buttons from product cards
 * Optimized to reduce main-thread blocking and improve performance
 */

// Debounce helper to reduce excessive calls
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

function cleanQuickAddButtons(root) {
  var context = root || document;

  // Use requestIdleCallback if available for non-blocking execution
  const processCards = () => {
    context.querySelectorAll('.product-card').forEach(function(card) {
      // Skip if already processed
      if (card.dataset.quickAddCleaned) return;

      var buttons = card.querySelectorAll(
        '.quick-add__submit, .card__quick-add, [data-add-to-cart], button[name="add"]'
      );

      if (buttons.length > 1) {
        // Hide ONLY the first quick-add style control
        buttons[0].style.display = 'none';
      }

      // Mark as processed to avoid reprocessing
      card.dataset.quickAddCleaned = 'true';
    });
  };

  // Use requestIdleCallback for better performance, fallback to setTimeout
  if ('requestIdleCallback' in window) {
    requestIdleCallback(processCards, { timeout: 1000 });
  } else {
    setTimeout(processCards, 0);
  }
}

// Optimized debounced version
const debouncedCleanup = debounce(cleanQuickAddButtons, 150);

// Wait for page to be fully loaded and interactive
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    // Delay initial cleanup slightly to not block initial render
    setTimeout(() => cleanQuickAddButtons(document), 100);
  });
} else {
  // DOM already loaded
  setTimeout(() => cleanQuickAddButtons(document), 100);
}

// Optimized observer with throttling
const observer = new MutationObserver(function(mutations) {
  let hasProductCards = false;

  // Quick check if any mutations contain product cards
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof Element)) continue;

      if (node.matches('.product-card') || node.querySelector('.product-card')) {
        hasProductCards = true;
        break;
      }
    }
    if (hasProductCards) break;
  }

  // Only run cleanup if product cards were actually added
  if (hasProductCards) {
    debouncedCleanup(document);
  }
});

// Start observing after a small delay to not impact initial load
setTimeout(() => {
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}, 500);

// Respond to Shopify's section reloads in the editor
document.addEventListener('shopify:section:load', function(event) {
  cleanQuickAddButtons(event.target);
});
